import { cx } from '@emotion/css';

import withControl, { WithControlRenderProps } from '../withControl';

import { errorClassName, textareaClassName } from './styles';
import { TextareaProps } from './types';

type Props = TextareaProps & WithControlRenderProps;

const Textarea = ({
  className = '',
  hasError,
  maxLength,
  name,
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
  onKeyUp,
  placeholder,
  ref,
  tabIndex,
  value,
}: Props) => {
  return (
    <textarea
      className={cx(textareaClassName, {
        [className]: !!className,
        [errorClassName]: hasError,
      })}
      maxLength={maxLength}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      placeholder={placeholder}
      ref={ref}
      tabIndex={tabIndex}
      value={value}
    />
  );
};

Textarea.displayName = 'Textarea';

export default withControl(Textarea);
